import React from 'react'
import styles from './styles.module.scss'

interface Props {
    children: React.ReactNode
    animationHandler?: boolean
    className?: string
    id?: string
}

export default function FixedBottomContainer(props: Props) {
    return (
        <aside id={props.id} className={`${styles.container} ${props.animationHandler ? styles.show : styles.hide} ${props.className ?? ""}`}>
            <div className={styles.subContainer}>
                {props.children}
            </div>
        </aside>
    )
}
